/**
 * CetusEd NextGen — Client API base URL.
 *
 * The single place the client decides WHERE the API is. It reads
 * `import.meta.env.VITE_API_URL`, which the deploy build injects
 * (staging: https://cetused-staging-api.onrender.com) and which defaults to the
 * local dev server otherwise. Never hardcode a deploy URL anywhere else — a
 * second source of truth is how a client ends up talking to the wrong backend.
 *
 * `VITE_API_URL` is declared `string` in vite-env.d.ts, but at RUNTIME an unset
 * env is `undefined`, so the `||` fallback is real, not decorative.
 */
const RAW_API_URL: string | undefined = import.meta.env.VITE_API_URL

/** Absolute API origin, no trailing slash. Falls back to the local dev server. */
export const API_BASE: string = (RAW_API_URL && RAW_API_URL.trim().length > 0
  ? RAW_API_URL
  : 'http://localhost:3000'
).replace(/\/+$/, '')
